import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ColorTokenTable from 'components/ColorTokenTable';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "tokens-by-theme"
    }}>{`Tokens by theme`}</h2>
    <ColorTokenTable mdxType="ColorTokenTable" />
    <h2 {...{
      "id": "color-and-accessibility"
    }}>{`Color and accessibility`}</h2>
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "/guidelines/accessibility/color"
      }}>{`accessibility section`}</a>{` for
complete guidance on color and accessibility in Carbon.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      